export const LOGIN_REQUESTING = 'LOGIN_REQUESTING'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_EXISTING = 'LOGIN_EXISTING'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_NO_REDIRECT = 'LOGOUT_NO_REDIRECT'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const UNSET_AUTHENTICATED = 'UNSET_AUTHENTICATED'
export const CHECK_AUTHENTICATED = 'CHECK_AUTHENTICATED'
